export default "__VITE_ASSET__Dz0oMn23__"